var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hvh-chart',{attrs:{"visualization":_vm.visualization,"options":_vm.chartOptions,"height":_vm.height},on:{"dataCreated":_vm.chartDataCreated,"item-clicked":_vm.itemClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }